import { render, staticRenderFns } from "./JobMatchPage.vue?vue&type=template&id=2fef4794&"
import script from "./JobMatchPage.vue?vue&type=script&lang=js&"
export * from "./JobMatchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports